import { render, staticRenderFns } from "./InformarFormaPgtoPedido.vue?vue&type=template&id=3367384a&"
import script from "./InformarFormaPgtoPedido.vue?vue&type=script&lang=js&"
export * from "./InformarFormaPgtoPedido.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports